"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeComponentV2 = void 0;
var react_1 = __importStar(require("react"));
var date_fns_1 = require("date-fns");
var icons_1 = require("../../../constants/icons");
var index_1 = require("../../../index");
var dropdown_1 = require("../../../types/dropdown");
var DateRangeMenu_1 = __importDefault(require("./DateRangeMenu"));
var dateRangePicker_constants_1 = require("./dateRangePicker.constants");
var DateRangeComponentV2 = function (_a) {
    var eventCallback = _a.eventCallback, onCategorySelect = _a.onCategorySelect, defaultCategoryValue = _a.defaultCategoryValue, finalDateRange = _a.finalDateRange, onDateChange = _a.onDateChange, range = _a.range, onRangeChange = _a.onRangeChange, className = _a.className, menuWrapperClassName = _a.menuWrapperClassName, id = _a.id, controlClassName = _a.controlClassName, _b = _a.disabled, disabled = _b === void 0 ? false : _b, customRangeOptions = _a.customRangeOptions, _c = _a.leadingIconClassname, leadingIconClassname = _c === void 0 ? '' : _c;
    var _d = react_1.useState(0), triggerClose = _d[0], setTriggerClose = _d[1];
    var _e = react_1.useState(false), isOpen = _e[0], setIsOpen = _e[1];
    var getTitle = function () {
        if (defaultCategoryValue.value === dateRangePicker_constants_1.DATE_FILTER_CATEGORIES.CUSTOM_DATE_RANGE &&
            finalDateRange.start &&
            finalDateRange.end)
            return date_fns_1.format(finalDateRange.start, 'dd MMM yyyy') + " - " + date_fns_1.format(finalDateRange.end, 'dd MMM yyyy');
        return "Date range - " + defaultCategoryValue.label;
    };
    return (react_1.default.createElement(index_1.CustomMenuDropdown, { borderClassName: 'tw-border-TEXT_TERTIARY', controlClassName: "tw-bg-white " + controlClassName, eventCallback: eventCallback, id: id, leadingIconProps: {
            className: "tw-mr-2 " + leadingIconClassname,
            height: 12,
            iconCategory: icons_1.ICON_SPRITE_TYPES.TIME,
            id: 'calendar',
            width: 12,
        }, size: dropdown_1.DROPDOWN_SIZE_TYPES.SMALLEST, title: getTitle(), triggerClose: triggerClose, childrenWrapperClassName: 'tw-max-h-[400px] !tw-overflow-visible', className: className, menuWrapperClassName: "tw-transition-all tw-duration-300 " + menuWrapperClassName, onToggleOpen: setIsOpen },
        react_1.default.createElement(DateRangeMenu_1.default, { eventCallback: eventCallback, onDateChange: onDateChange, range: range, onRangeChange: onRangeChange, onCategorySelect: onCategorySelect, setTriggerClose: setTriggerClose, disabled: disabled, defaultCategoryValue: defaultCategoryValue, id: id, customRangeOptions: customRangeOptions, isOpen: isOpen })));
};
exports.DateRangeComponentV2 = DateRangeComponentV2;
